import { Button, FontIcon } from '@intigral/shared';
import { Program } from '@intigral/ui';
import React from 'react';
import { ButtonTypes } from '../../config/constants';
import h from '../../helpers/common';
import { __ } from '../../translations';
import LockIcon from './LockIcon';
import PlayVideoButton from './PlayVideoButton';
import AddWatchlistButton from './AddWatchlistButton';
import usePPVManagement from '../../hooks/usePPVManagement';
import { useConfiguration } from '../../hooks/useConfiguration';

interface WatchListEpisodeItemProps {
    item: any;
    onRemove: () => void;
    componentType: string;
    componentName: string;
    id: string;
}

const WatchListEpisodeItem: React.FC<WatchListEpisodeItemProps> = ({
    item,
    onRemove,
    componentType,
    componentName,
    id,
}) => {
    // Use PPV management hook for all PPV-related functionality
    const { shouldShowLock } = usePPVManagement();

    const channelId = item?.channelId || item?.channelID || item?.id;
    const { isLocked } = shouldShowLock(item, channelId);

    const { data: newConfig } = useConfiguration();
    return (
        <div className="masonry-item" id={id}>
            <Program
                program={{
                    duration: '',
                    name: '',
                    showProgress: false,
                    progress: 0,
                    channelImage: null,
                    channelTitle: '',
                    isReminderSet: false,
                    poster: h.getImagizerUrl(
                        item?.image_landscape
                            ? item?.image_landscape
                            : item?.images?.find((img) => img.type === 'cover')?.url,
                        newConfig?.imagizer?.components_images.WATCHLIST_SEASON_EPISODES_ITEM
                    ),
                    showPlay: false,
                    text: item.text,
                    badge: isLocked ? <LockIcon corner /> : undefined,
                }}
                assetDetails={{
                    info: [
                        item.ratings && typeof item.ratings === 'string' ? item.ratings.toUpperCase() : null,
                        Array.isArray(item.genre) ? item.genre : [],
                        item.episodeNumber ? `${__('tv_episode_number_short')} ${item.episodeNumber}` : null,
                        item.seasonNumber ? `${__('tv_episode_season_number_short')} ${item.seasonNumber}` : null,
                        item.year ? `${item.year}` : null,
                    ],
                }}
                CTAs={[
                    !isLocked ? (
                        <PlayVideoButton
                            buttonType={ButtonTypes.EpisodeItem}
                            item={item}
                            componentType={componentType}
                            componentName={componentName}
                        >
                            <Button primary social compact>
                                <FontIcon name="play" size="smaller" md="smaller" />
                            </Button>
                        </PlayVideoButton>
                    ) : (
                        <LockIcon inline />
                    ),
                    <AddWatchlistButton
                        item={item}
                        type={ButtonTypes.VodeItem}
                        onRemove={onRemove}
                        componentType={componentType}
                        componentName={componentName}
                    />,
                ]}
                noHeight
            />
        </div>
    );
};
export default WatchListEpisodeItem;
